/**
 * Gracefully taken from https://stackoverflow.com/a/31676948/6443429
 */ 
export class TextHighlighterFilter {
    //This will wrap matching search terms with an element to visually highlight strings
    //Usage: {{fullString | highlight:'partial string'}}
    //Usage: {{fullString | highlight:['partial', 'string, 'example']}}

    static $inject = ["$sce"];

    constructor($sce: ng.ISCEService) {

        // The `terms` could be a string, or an array of strings, so we have to use the `any` type here
        /* tslint:disable: no-any */
        return (str: string, terms: any) => {
            /* tslint:enable */

            if (terms) {
                let allTermsRegexStr: string;

                if (typeof terms === "string") {
                    allTermsRegexStr = terms;
                } else { //assume a string array
                    // Sort array by length then  join with regex pipe separator
                    allTermsRegexStr = terms.sort((a: string, b: string) => b.length - a.length).join('|');
                }

            //Escape characters that have meaning in regular expressions
            //via: http://stackoverflow.com/a/6969486/79677
            allTermsRegexStr = allTermsRegexStr.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

                // Regex to simultaneously replace terms - case insensitive!
                var regex = new RegExp('(' + allTermsRegexStr + ')', 'ig');

                return $sce.trustAsHtml(str.replace(regex, '<mark class="highlight">$&</mark>'));
            } else {
                return str;
            }
        };
    }
}